import React, { useEffect, useState } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory, useParams } from 'react-router'
import SimpleTable from '../helper/SimpleTable';
import Loading from '../helper/Loading';
import axios from 'axios';
//import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import DetailDialog from '../helper/DetailDialog';
import {permissionsMap} from './AdminRolesManage';


const UserLog = props => {

  const {t} = props;

  const tableCells = [
    // { id: 'id', label: 'ID', centered: false },
    { id: 'createDATE', label: t('UsersLog.Date'), centered: false },
    { id: 'notes', label: t('UsersLog.LogMessage'), centered: false }
  ];
  

  const fieldToLabel = {
    username: t('UsersLog.Username'),
    createdByUsername: t('UsersLog.UpdatedBy'),
    createDATE: t('UsersLog.CreateDate'),
    first_name: t('UsersLog.FirstName'),
    middle_name: t('UsersLog.MiddleName'),
    last_name: t('UsersLog.LastName'),
    suffix: t('UsersLog.Suffix'),
    title: t('UsersLog.Title'),
    dob: t('UsersLog.DOB'),
    primaryEMAIL: t('UsersLog.PrimaryEmail'),
    secondaryEMAIL: t('UsersLog.SecondaryEmail'),
    companyEmployed: t('UsersLog.CompanyEmployed'),
    mailingAddressIsWorkLocation: t('UsersLog.HasWorkLocation'),
    workName: t('UsersLog.WorkName'),
    workStreet: t('UsersLog.WorkStreet'),
    workCity: t('UsersLog.WorkCity'),
    workStateCode: t('UsersLog.WorkState'),
    workCountyCode: t('UsersLog.WorkCountry'),
    workZipCode: t('UsersLog.WorkZip'),
    workPhone: t('UsersLog.WorkPhone'),
    jobTitle: t('UsersLog.JobTitle'),
    homeStreet: t('UsersLog.HomeStreet'),
    homeCity: t('UsersLog.HomeCity'),
    homeStateCode: t('UsersLog.HomeState'),
    homeCountyCode: t('UsersLog.HomeCounty'),
    homeZipCode: t('UsersLog.HomeZip'),
    homePhone: t('UsersLog.HomePhone'),
    permissions: 'Permissions'
  }
  const history = useHistory()
  const params = useParams()

  const [data, setData] = useState(null);
  const [name, setName] = useState(null);
  const [details, setDetails] = useState({ open : false, data: null, exists: false, dates: null }) // format = {data : [], exists : bool, date: {current, prev}}
  // const [dialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    async function getData() {
      let res = await axios.get('/api/user/log/' + params.username);

      //console.log('res',res)
      const data = res.data.map(e => {
        e.createDATE = moment(e.createDATE).format('YYYY-MM-DD HH:mm:ss');
        if (e.dob) e.dob = moment(e.dob).format('YYYY-MM-DD');
        if(e.permissions){
          let tempP = e.permissions;
          let storePer = e.permissions;
          console.log('stored perm', storePer);
          let newPermArr = tempP.split(',');
          e.permissions = "";
          for(let j=0;j< newPermArr.length;j++){
            
            for(let i=0;i<permissionsMap.length;i++){
              if(permissionsMap[i].num=== newPermArr[j] ){
                e.permissions = e.permissions  +permissionsMap[i].title + ',';
              }
            }
          }
         
          
        }
        
        return e
      })

      setData(data);
      let latest = data.length - 1
      setName(data[latest].first_name + ' ' + data[latest].last_name)
      console.log('data', data);
    }
    getData();

  }, [params.username])

  const onDetails = (id) => {
    //console.log("details clicked", id);

    // the most recent is the first element, the oldest is the last element

    //get the current and previous user logs
    let currentIndex = data.findIndex(x => x.ID === id);
    const prevExists = currentIndex === 0 ? false : true


    if (currentIndex === -1) {
      console.log("Error")
      return
    }


    let currentLog = data[currentIndex];
    let lastLog = prevExists ? data[currentIndex - 1] : null;

    let key
    let tableData = []
    const currentDate = currentLog.createDATE
    const prevDate = prevExists ? lastLog.createDATE : null
    for (key in currentLog) {
      // if the key is not in the dict, then ignore it
      if (fieldToLabel[key] === undefined) continue

      let prev = "-"
      if (prevExists === true) {
        prev = lastLog[key] === true ? 'Yes' : lastLog[key] === false ? 'No' : lastLog[key]
      } 
      let current = currentLog[key]
      current = current === true ? 'Yes' : current === false ? 'No' : current
      
      const changed = prevExists && prev !== current

      tableData.push({
        field: fieldToLabel[key],
        prev,
        current,
        changed,

      })
    }

    //console.log(tableData)

    //console.log(currentIndex, currentLog, lastLog)

    setDetails({ open: true, data: tableData, exists: prevExists, dates: { current: currentDate, prev: prevDate } })
    // setDialogOpen(true)

  }


  const actionButtons = [
    { icon: "details", label: t('UsersLog.Details'), action: onDetails, delete: false }
  ];

  return (
    <>
      <PageHeader title={params.username + ' '+t('UsersLog.MyProfileLogs')} cancel={history.goBack} />
      {data === null ? <Loading /> :
        data.length === 0 ? <h1>No data found</h1> :
          <>
            <p>Name: {name}</p>
            <DetailDialog open={details.open} onClose={() => setDetails({...details, open: false})} data={details.data} prevExists={details.exists} dates={details.dates} />
            <SimpleTable
              data={data}
              cellKey={"ID"}
              tableCells={tableCells}
              actionButtons={actionButtons}
              actions={true}
              />
          </>
      }


    </>
  )
}

export default withTranslation()(UserLog);